module.exports = __webpack_public_path__ + "img/edit.563fb3c1.svg";